import SoundManager from "../../../../../lib/html5-software-library/src/ranj/audio/SoundManager";
import TextContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/TextContent";
import SoundType from "../../../core/sound/SoundType";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import PlaceholderEvent from "../event/PlaceholderEvent";

export default class PlaceholderScreenMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {AssetLibrary} assetLibrary 
     * @param {RevisableLanguagePack} languagePack 
     * @param {SoundManager} soundManager 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, soundManager) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._languagePack = languagePack;
        this._soundManager = soundManager;

        /** @type {TextContent} */
        this._content = this.getCustomData().content;
    }

    initialize() {
        super.initialize();
        this.preventClickThrough();

        this._target.contentTextField.text = this._content.getText();

        this._continueButton = this.createButton(this._target.continueButton, this._handleContinueButton.bind(this), this._languagePack.getText('placeholder.continueButtonLabel'), SoundType.SOUND_CLICK);
    }

    _handleContinueButton() {
        this._continueButton.setEnabled(false);

        this.dispatch(PlaceholderEvent.CLOSE_REQUEST);
    }
}